export enum LanguageSwitcherTheme {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum LanguageSwitcherLinkDisplay {
  FULL = 'full',
  ACRONYM = 'acronym',
}
